import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { AutorenewIcon, PanToolIcon } from "../../icons";
import { localDateTime, localTime } from "./localDateTime";
/**
 * Indicador de reintentos legible: "intento k/N" + hora del próximo reintento.
 * Texto en text.primary/secondary del theme (contraste AA, dark-mode safe).
 */
export const RetryIndicator = ({
  retryCount,
  maxAttempts = 5,
  manualRetryCount = 0,
  nextRetryAt,
}: {
  retryCount?: number | null;
  maxAttempts?: number;
  manualRetryCount?: number | null;
  nextRetryAt?: string | null;
}) => {
  const auto = retryCount ?? 0;
  const manual = manualRetryCount ?? 0;
  if (auto === 0 && manual === 0 && !nextRetryAt) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, whiteSpace: "nowrap" }}>
      {auto > 0 && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <AutorenewIcon fontSize="small" color="warning" />
          <Typography variant="body2" sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
            intento {auto}/{maxAttempts}
          </Typography>
        </Box>
      )}
      {manual > 0 && (
        <Tooltip title="Reintentos manuales del operador">
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <PanToolIcon fontSize="small" color="info" />
            <Typography variant="body2">{manual}</Typography>
          </Box>
        </Tooltip>
      )}
      {nextRetryAt && (
        <Tooltip title={localDateTime(nextRetryAt)}>
          <Typography variant="body2" color="text.secondary">
            próximo ~{localTime(nextRetryAt)}
          </Typography>
        </Tooltip>
      )}
    </Box>
  );
};
